"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _reactRouterDom = require("react-router-dom");
var _useResolutionCheck2 = _interopRequireDefault(require("../../useResolutionCheck"));
var _NotifyIcon = _interopRequireDefault(require("../../NotifyIcon"));
var _NotifyTypo = _interopRequireDefault(require("../../NotifyTypo"));
var _elements = _interopRequireDefault(require("./elements"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Heading2 = _NotifyTypo["default"].Heading2,
  InfoText = _NotifyTypo["default"].InfoText;
var ContentPageHeader = function ContentPageHeader(_ref) {
  var className = _ref.className,
    header = _ref.header,
    subHeader = _ref.subHeader,
    backUrl = _ref.backUrl,
    action = _ref.action,
    embedded = _ref.embedded,
    consistentHeight = _ref.consistentHeight;
  var _useResolutionCheck = (0, _useResolutionCheck2["default"])(),
    isDesktop = _useResolutionCheck.isDesktop;
  return /*#__PURE__*/_react["default"].createElement(_elements["default"], {
    className: className,
    embedded: embedded,
    consistentHeight: consistentHeight
  }, /*#__PURE__*/_react["default"].createElement("div", null, isDesktop && backUrl && /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    "aria-label": "back",
    color: "inherit",
    component: _reactRouterDom.Link,
    to: backUrl,
    style: {
      marginRight: '2rem'
    }
  }, /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
    iconName: "backArrow"
  })), /*#__PURE__*/_react["default"].createElement("div", null, typeof header === 'string' ? /*#__PURE__*/_react["default"].createElement(Heading2, {
    gutterBottom: subHeader && true || false
  }, header) : header, subHeader && (typeof subHeader === 'string' ? /*#__PURE__*/_react["default"].createElement(InfoText, null, subHeader) : subHeader))), action && /*#__PURE__*/_react["default"].createElement("div", null, action));
};
ContentPageHeader.propTypes = {
  className: _propTypes["default"].string,
  header: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]).isRequired,
  subHeader: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]).isRequired,
  backUrl: _propTypes["default"].string,
  action: _propTypes["default"].node,
  embedded: _propTypes["default"].bool,
  consistentHeight: _propTypes["default"].bool
};
ContentPageHeader.defaultProps = {
  className: '',
  backUrl: '',
  subHeader: '',
  action: null,
  embedded: false,
  consistentHeight: false
};
var _default = exports["default"] = ContentPageHeader;